import { MediaPlayer } from "dashjs";
import { useEffect } from "react";
import { useState } from "react";
import { useMediaPlayer } from "@/shared/ui";

export function useLiveDelay() {
  const [isLiveEdge, setIsLiveEdge] = useState(false);
  const [liveDelay, setLiveDelay] = useState<string>("0");
  const mediaPlayer = useMediaPlayer();
  const liveThresholdSecs = 1;

  useEffect(() => {
    const onPlaybackTimeUpdated = () => {
      if (mediaPlayer.isDynamic() && mediaPlayer.duration()) {
        const liveDelay = mediaPlayer.duration() - mediaPlayer.time();

        const targetLiveDelay = mediaPlayer.getTargetLiveDelay();

        if (liveDelay < targetLiveDelay + liveThresholdSecs) {
          setIsLiveEdge(true);
        } else {
          setIsLiveEdge(false);
        }

        setLiveDelay(Number(liveDelay).toFixed(1) + "s");
      }
    };

    mediaPlayer.on(
      MediaPlayer.events.PLAYBACK_TIME_UPDATED,
      onPlaybackTimeUpdated
    );

    return () => {
      mediaPlayer.off(
        MediaPlayer.events.PLAYBACK_TIME_UPDATED,
        onPlaybackTimeUpdated
      );
    };
  }, [mediaPlayer]);

  return { liveDelay, isLiveEdge };
}
